import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useIsAgentRoleIndia, useIsAgentRoleUSA } from "./roleContext";
import { paths } from "./router";

const useRedirectWithoutRole = (
  requiredRole: boolean,
  destinationPath: string,
) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (!requiredRole) {
      navigate(destinationPath);
    }
  }, [requiredRole, navigate, destinationPath]);
};

export const useSecureMailRedirectWithoutRole = () => {
  const indiaRole = useIsAgentRoleIndia();
  const usaRole = useIsAgentRoleUSA();
  useRedirectWithoutRole(usaRole || indiaRole, paths.root);
};

export const useUsaRedirectWithoutRole = () => {
  useRedirectWithoutRole(useIsAgentRoleUSA(), paths.root);
};
